





















import Vue, { PropType } from 'vue';
import { mapMutations } from 'vuex';
import {
    tConvert, timeToHoursAndMinutes, incrementTimeBySeconds, convertDateToAmericanFormat,
} from '../../lib/utils';

export default Vue.extend({
    props: {
        ridesData: {
            type: Array as PropType<any>,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            headers: [
                // {
                //     text: '',
                //     value: 'passengers',
                //     width: 50,
                // },
                { text: 'Route', value: 'routeName' },
                {
                    text: 'Planned Departure',
                    value: 'plannedDeparture',
                },
                {
                    text: 'Actual Departure',
                    value: 'actualDeparture',
                },
                {
                    text: 'Planned Arrival',
                    value: 'plannedArrival',
                },
                {
                    text: 'Actual Arrival',
                    value: 'actualArrival',
                },
                {
                    text: 'Booked',
                    value: 'booked',
                    align: 'center',
                },
                {
                    text: 'Boarded',
                    value: 'boardedPassengers',
                    align: 'center',
                },
            ],
            data: [] as PropType<object>,
        };
    },
    methods: {
        ...mapMutations('rides', ['setRoute']),
        onRowSelect(row: any, rowDetails: any) {
            this.setRoute(`${convertDateToAmericanFormat(row.date)} ${row.routeName} ${tConvert(row.plannedDeparture)}`);
            this.$router.push(`/rides/${row.rideId}/passengers`);
        },
        row_classes(item: any) {
            if (item.hasEnded) {
                return 'text--disabled';
            }
            if (item.hasStarted && !item.hasEnded) {
                return 'font-weight-medium';
            }
            if (item.isCancelled) {
                return 'text-decoration-line-through';
            }
            return 'text--primary';
        },
        getStopDepratTime(stop: any) {
            if (stop && stop.actualArrival && (stop.actualAtopTimeSec === 0 || stop.actualAtopTimeSec > 0)) {
                return timeToHoursAndMinutes(incrementTimeBySeconds(stop.actualAtopTimeSec, stop.actualArrival));
            }
            return null;
        },
        getFirstStopDepratTime(stops: Array<any>) {
            if (stops.length > 0) {
                return this.getStopDepratTime(stops[0]);
            }
            return null;
        },
        tConvert,
    },
    watch: {
        ridesData: {
            deep: true,
            handler(newVal) {
                this.data = newVal;
            },
        },
    },
    created() {
        this.data = this.ridesData;
    },
});
